module.exports = "\r\n.red-button {\r\n\r\n    color: #ff0000;  \r\n    background-color: #ff9999;\r\n    padding: 4px 20px;\r\n    border: 2px solid #ff0000; \r\n    border-radius: 5px; \r\n    font-size: 16px; \r\n    cursor: pointer; \r\n}\r\n\r\n.red-button:hover {\r\n    background-color: #ff9999;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shoppingcart/promo-code/promo-code.component.css
// module id = ./src/app/shoppingcart/promo-code/promo-code.component.css
// module chunks = main